export default __webpack_public_path__ + "static/media/spinner.41aa5208.gif";